var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 27 24",
    className: "elrond-symbol body",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11028 -19030)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-1",
    d: "M24.75-21H2.25A2.251,2.251,0,0,0,0-18.75v13.5A2.251,2.251,0,0,0,2.25-3h22.5A2.251,2.251,0,0,0,27-5.25v-13.5A2.251,2.251,0,0,0,24.75-21ZM22.5,1.875A1.122,1.122,0,0,0,21.375.75H16.753l-.872-2.616a.56.56,0,0,0-.534-.384H11.658a.56.56,0,0,0-.534.384L10.252.75H5.625a1.125,1.125,0,0,0,0,2.25h15.75A1.122,1.122,0,0,0,22.5,1.875Z",
    transform: "translate(-11028 19051)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11019.5 19034)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M360.895,396.416a.164.164,0,0,1-.059-.129.16.16,0,0,1,.059-.129.213.213,0,0,1,.28,0,.164.164,0,0,1,.059.129.16.16,0,0,1-.059.129.212.212,0,0,1-.28,0",
    transform: "translate(-352.894 -394.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M353.313,404.289a.207.207,0,0,1-.05-.129.19.19,0,0,1,.19-.19.157.157,0,0,1,.129.059.206.206,0,0,1,.05.129.179.179,0,0,1-.05.129.206.206,0,0,1-.129.05.2.2,0,0,1-.14-.048",
    transform: "translate(-345.813 -401.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M344.848,412.383a.187.187,0,0,1,0-.26h0a.2.2,0,0,1,.268,0,.187.187,0,0,1,0,.26.164.164,0,0,1-.129.059.179.179,0,0,1-.14-.059",
    transform: "translate(-337.896 -409.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M336.759,420.355a.187.187,0,0,1-.011-.26l.011-.011a.212.212,0,0,1,.28,0,.187.187,0,0,1,.011.26l-.011.011a.219.219,0,0,1-.28,0",
    transform: "translate(-330.327 -416.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M329.052,428.706a.164.164,0,0,1-.059-.129.179.179,0,0,1,.19-.179.164.164,0,0,1,.12.05.157.157,0,0,1,.05.129.19.19,0,0,1-.19.19.318.318,0,0,1-.112-.062",
    transform: "translate(-323.12 -424.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M320.516,436.64a.157.157,0,0,1,.059-.129.187.187,0,0,1,.268.26.187.187,0,0,1-.26,0A.178.178,0,0,1,320.516,436.64Z",
    transform: "translate(-315.193 -432.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M304.875,452.357a.143.143,0,0,1-.05-.129.179.179,0,0,1,.05-.129.2.2,0,0,1,.268,0,.189.189,0,0,1,.05.129.161.161,0,0,1-.059.129.165.165,0,0,1-.129.059.157.157,0,0,1-.131-.059",
    transform: "translate(-300.519 -446.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M296.3,460.533a.165.165,0,0,1-.059-.129.173.173,0,0,1,.059-.129.228.228,0,0,1,.291,0,.165.165,0,0,1,.059.129.173.173,0,0,1-.059.129.2.2,0,0,1-.14.059.364.364,0,0,1-.151-.059",
    transform: "translate(-292.5 -454.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M288.735,468.5a.19.19,0,1,1,.268,0,.2.2,0,0,1-.268,0",
    transform: "translate(-285.428 -461.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M280.641,476.539a.177.177,0,0,1-.059-.129.2.2,0,0,1,.19-.19.179.179,0,0,1,.129.05.206.206,0,0,1,.05.129.184.184,0,0,1-.05.129.207.207,0,0,1-.129.05.126.126,0,0,1-.131-.039",
    transform: "translate(-277.854 -469.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M272.207,484.8a.164.164,0,0,1-.059-.129.157.157,0,0,1,.059-.129.212.212,0,0,1,.28,0,.164.164,0,0,1,.059.129.157.157,0,0,1-.059.129.213.213,0,0,1-.28,0",
    transform: "translate(-269.967 -477.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M264.594,492.646a.2.2,0,0,1,0-.268h0a.188.188,0,0,1,.26,0,.2.2,0,0,1,0,.268.188.188,0,0,1-.26,0",
    transform: "translate(-262.856 -484.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M264.643,396.285a.206.206,0,0,0,.05-.129.19.19,0,0,0-.19-.19.179.179,0,0,0-.129.05.164.164,0,0,0-.059.129.157.157,0,0,0,.059.129.188.188,0,0,0,.268.011",
    transform: "translate(-262.644 -394.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M272.486,404.419a.164.164,0,0,0,.059-.129.157.157,0,0,0-.059-.129.213.213,0,0,0-.28,0,.164.164,0,0,0-.059.129.157.157,0,0,0,.059.129.212.212,0,0,0,.28,0",
    transform: "translate(-269.967 -401.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M280.78,412.383a.187.187,0,0,0,0-.26.2.2,0,0,0-.268,0,.249.249,0,0,0-.059.129.179.179,0,0,0,.05.129.164.164,0,0,0,.129.059.169.169,0,0,0,.148-.056",
    transform: "translate(-277.733 -409.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M289,420.395a.19.19,0,1,0-.268,0,.168.168,0,0,0,.129.05.237.237,0,0,0,.14-.05",
    transform: "translate(-285.428 -416.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M296.756,428.568a.164.164,0,0,0,.059-.129.161.161,0,0,0-.059-.129.191.191,0,0,0-.28,0,.165.165,0,0,0-.059.129.161.161,0,0,0,.059.129.213.213,0,0,0,.28,0",
    transform: "translate(-292.661 -424.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M305.191,436.564a.157.157,0,0,0-.059-.129.187.187,0,0,0-.26,0h0a.2.2,0,0,0,0,.268h0a.2.2,0,0,0,.268,0A.267.267,0,0,0,305.191,436.564Z",
    transform: "translate(-300.517 -432.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M313.145,444.665a.19.19,0,1,0-.268,0h0a.2.2,0,0,0,.268,0",
    transform: "translate(-308.001 -439.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M320.9,452.357a.164.164,0,0,0,.059-.129.16.16,0,0,0-.059-.129.213.213,0,0,0-.28,0,.164.164,0,0,0-.059.129.161.161,0,0,0,.059.129.2.2,0,0,0,.14.059.186.186,0,0,0,.14-.059",
    transform: "translate(-315.233 -446.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M329.191,460.533a.189.189,0,0,0,.05-.129.2.2,0,0,0-.05-.129.2.2,0,0,0-.268,0,.177.177,0,0,0-.059.129.186.186,0,0,0,.19.179.2.2,0,0,0,.137-.05",
    transform: "translate(-322.999 -454.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M337.458,468.5a.19.19,0,0,0-.268-.268h0a.2.2,0,0,0,0,.268h0a.168.168,0,0,0,.129.05.245.245,0,0,0,.14-.05",
    transform: "translate(-330.734 -461.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M345.139,476.67a.178.178,0,0,0,.059-.129.157.157,0,0,0-.059-.129.187.187,0,0,0-.26,0,.206.206,0,0,0-.05.129.18.18,0,0,0,.05.129.168.168,0,0,0,.129.05.16.16,0,0,0,.131-.05",
    transform: "translate(-337.927 -469.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M353.546,484.642a.183.183,0,0,0,.059-.14.157.157,0,0,0-.059-.129.187.187,0,0,0-.26,0,.143.143,0,0,0-.05.129.186.186,0,0,0,.31.14",
    transform: "translate(-345.785 -476.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2",
    d: "M361.289,492.605a.2.2,0,0,0,.011-.26l-.011-.011a.213.213,0,0,0-.28,0,.182.182,0,0,0-.02.249l.02.02a.193.193,0,0,0,.28,0",
    transform: "translate(-353 -484.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2 reverse",
    d: "M272.158,372.474a3.251,3.251,0,0,1,3.514,0l1.129-1.118a4.65,4.65,0,0,0-5.773,0Z",
    transform: "translate(-268.921 -370.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2 reverse",
    d: "M240.691,407.354a3.165,3.165,0,0,1,0-3.514l-1.118-1.118a4.676,4.676,0,0,0,0,5.753Z",
    transform: "translate(-238.583 -400.619)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2 reverse",
    d: "M275.684,491.281a3.147,3.147,0,0,1-3.536.008l-1.118,1.118a4.545,4.545,0,0,0,2.9,1,4.619,4.619,0,0,0,2.865-1.009Z",
    transform: "translate(-268.921 -483.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2 reverse",
    d: "M359.588,403.8a3.057,3.057,0,0,1,.528,1.786,3.221,3.221,0,0,1-.528,1.728l1.129,1.118a4.639,4.639,0,0,0,1.009-2.857,4.545,4.545,0,0,0-1-2.9Z",
    transform: "translate(-351.727 -400.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2 reverse",
    d: "M366.229,496.488a.788.788,0,1,1-.788.788h0a.8.8,0,0,1,.788-.788h0",
    transform: "translate(-357.2 -488.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2 reverse",
    d: "M242.737,496.488a.789.789,0,1,1-.758.758.8.8,0,0,1,.758-.758",
    transform: "translate(-241.758 -488.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2 reverse",
    d: "M366.651,372.729a.789.789,0,0,1,.78.788.78.78,0,0,1-1.56,0,.792.792,0,0,1,.78-.791",
    transform: "translate(-357.602 -372.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-webwallet-2 reverse",
    d: "M242.168,372.729a.783.783,0,0,1,.788.769h0a.789.789,0,0,1-.788.78h0a.774.774,0,1,1,0-1.549",
    transform: "translate(-241.198 -372.574)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebWallet);
export default __webpack_public_path__ + "static/media/web-wallet.89f8d37290193eadd9091cb7dcd73f7a.svg";
export { ForwardRef as ReactComponent };